/* Lemuria PDP enhancements
 * 1. Inject grams chip next to price (candles only)
 * 2. Tabs (V balení / Doručenie / Starostlivosť) — switch panels
 * 3. V balení per variant — swap content when variant changes
 */
(function () {
  if (window.__lemPdpInit) return;
  window.__lemPdpInit = true;

  function init() {
    initTabs();
    initGramsChip();
    initVariantSwap();
  }

  /* ─── Tabs ─── */
  function initTabs() {
    const tablists = document.querySelectorAll('.lem-tabs__list');
    tablists.forEach((list) => {
      const btns = list.querySelectorAll('.lem-tabs__btn');
      const panels = list.parentElement.querySelectorAll('.lem-tabs__panel');
      btns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const tab = btn.dataset.tab;
          btns.forEach((b) => b.setAttribute('aria-selected', b === btn ? 'true' : 'false'));
          panels.forEach((p) => {
            const isActive = p.dataset.panel === tab;
            if (isActive) {
              p.removeAttribute('hidden');
              p.dataset.active = 'true';
              if (tab === 'recenzie') ensureJudgeMeRendered();
            } else {
              p.setAttribute('hidden', '');
              p.dataset.active = 'false';
            }
          });
        });
      });
    });
  }

  /* ─── Judge.me lazy load + fallback ───
     Widget je hidden v tabe → Judge.me ho neinicializuje (lazy load).
     Pri kliknutí na Recenzie:
       1) Trigger viewport check pre Judge.me
       2) Po 2.5s ak je widget stále prázdny → ukáž fallback "Buďte prvý, kto napíše recenziu"
  */
  let jmTriggered = false;
  function ensureJudgeMeRendered() {
    const widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    if (jmTriggered) return; // už sme to skúsili
    jmTriggered = true;

    // Force-trigger Judge.me lazy detection
    setTimeout(() => {
      widget.scrollIntoView({ behavior: 'instant', block: 'center' });
      window.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));
    }, 50);

    // Fallback after 2.5s — ak Judge.me nič nevykreslil
    setTimeout(() => {
      if (widget.children.length === 0 && (widget.innerText || '').trim() === '') {
        const productTitle = (document.querySelector('h1')?.textContent || '').trim();
        const subject = encodeURIComponent('Recenzia produktu: ' + productTitle);
        const fallback = document.createElement('div');
        fallback.className = 'lem-recenzie__empty';
        fallback.innerHTML = `
          <div class="lem-recenzie__empty-stars" aria-hidden="true">★★★★★</div>
          <p class="lem-recenzie__empty-title">Zatiaľ žiadne recenzie</p>
          <p class="lem-recenzie__empty-sub">Po zakúpení a doručení vám automaticky pošleme email s pozvánkou na napísanie recenzie. Vaša skúsenosť pomôže ostatným pri výbere.</p>
          <div class="lem-recenzie__empty-actions">
            <a class="lem-recenzie__empty-cta" href="mailto:obchod@lemuriaspirit.sk?subject=${subject}">Podeliť sa o skúsenosť emailom</a>
            <a class="lem-recenzie__empty-link" href="/pages/contact">Alebo nás kontaktujte →</a>
          </div>
        `;
        widget.appendChild(fallback);
      }
    }, 2500);
  }

  /* ─── Grams chip injection ─── */
  function initGramsChip() {
    const dataEl = document.getElementById('lem-pdp-grams-data');
    if (!dataEl) return; // not a candle
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const variants = data.variants || {};
    let currentId = String(data.currentVariantId);

    function renderChip(variantId) {
      const v = variants[variantId];
      if (!v) return null;
      // Build chip parts: dim · grams (no burning hours, no garancia)
      const parts = [];
      if (v.dim) parts.push(v.dim);
      if (v.grams && v.grams > 0) parts.push(v.grams + ' g');
      if (parts.length === 0) return null;
      const chip = document.createElement('span');
      chip.className = 'lem-pdp-grams-chip';
      chip.dataset.lemGrams = '';
      chip.innerHTML =
        '<span class="lem-pdp-grams-chip__sep">/</span>' +
        ' ' + parts.join(' <span class="lem-pdp-grams-chip__sep">·</span> ');
      return chip;
    }

    function injectInto(priceEl) {
      if (!priceEl) return;
      // Remove any existing chip
      priceEl.querySelectorAll('[data-lem-grams]').forEach((n) => n.remove());
      const chip = renderChip(currentId);
      if (chip) priceEl.appendChild(chip);
    }

    function findPriceContainers() {
      // Horizon block uses class "price" inside product-details
      // Look in product info area, not sticky cart
      const main = document.querySelector('.product-information, .product-details, [class*="product-details"]');
      if (!main) return [];
      // Find price element
      return Array.from(main.querySelectorAll('.price, .price__regular, [class*="price-item--regular"]')).slice(0, 1);
    }

    function refresh() {
      const targets = findPriceContainers();
      targets.forEach(injectInto);
    }

    refresh();
    // Multi-pass refresh so Horizon's price re-render doesn't strip the chip
    [50, 250, 600, 1200].forEach(d => setTimeout(refresh, d));

    function syncFromUrl() {
      const v = new URL(location.href).searchParams.get('variant');
      if (v && variants[v] && v !== currentId) currentId = v;
      refresh();
      // Re-inject after Horizon settles
      [50, 200, 500].forEach(d => setTimeout(refresh, d));
    }

    // Listen to Horizon's native variant change event
    document.addEventListener('variant:change', (e) => {
      if (e.detail && e.detail.variant) currentId = String(e.detail.variant.id);
      else syncFromUrl();
      refresh();
      [50, 200, 500].forEach(d => setTimeout(refresh, d));
    });

    // Variant pickers fire native input change too — listen broadly
    document.addEventListener('change', (e) => {
      if (e.target && e.target.matches && e.target.matches('variant-picker input[type="radio"]')) {
        const vid = e.target.dataset.variantId;
        if (vid && variants[vid]) currentId = vid;
        refresh();
        [50, 200, 500].forEach(d => setTimeout(refresh, d));
      }
    });

    // URL change watcher (Horizon updates ?variant=... on selection)
    let lastUrl = location.href;
    new MutationObserver(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        syncFromUrl();
      }
      // Also re-inject if Horizon re-rendered price and chip is gone
      const main = document.querySelector('.product-information, .product-details, [class*="product-details"]');
      if (main && !main.querySelector('[data-lem-grams]')) refresh();
    }).observe(document.body, { subtree: true, childList: true });
  }

  /* ─── V balení per variant swap ─── */
  function initVariantSwap() {
    const items = document.querySelectorAll('.lem-vbaleni-item');
    if (!items.length) return;

    function showVariant(variantId) {
      let found = false;
      items.forEach((it) => {
        if (it.dataset.variantId === String(variantId)) {
          it.removeAttribute('hidden');
          found = true;
        } else {
          it.setAttribute('hidden', '');
        }
      });
      // Fallback: if no match, show first
      if (!found && items[0]) items[0].removeAttribute('hidden');
    }

    document.addEventListener('variant:change', (e) => {
      if (e.detail && e.detail.variant) showVariant(e.detail.variant.id);
    });

    // Also URL listener as backup
    let lastUrl = location.href;
    new MutationObserver(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        const url = new URL(location.href);
        const v = url.searchParams.get('variant');
        if (v) showVariant(v);
      }
    }).observe(document, { subtree: true, childList: true });
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
